import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form"; //getFormValues
import MenuItem from "material-ui/MenuItem";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import { TextField, SelectField } from "redux-form-material-ui";
import { Flex, Box } from "rebass";

const required = value => (value == null ? "Required" : undefined);
const valuemin = value =>
  value.trim() === "" ? "Can not be empty" : undefined;

class ModalEditDetail extends Component {
  handleClose = () => {
    this.props.handleClose();
  };
  onSubmit = values => {
    this.props.handleSave(values);
  };
  render() {
    const { handleSubmit, submitting } = this.props;

    return (
      <div>
        <Dialog
          title="Edit"
          modal={true}
          open={this.props.open}
          autoScrollBodyContent={true}
        >
          <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
            <Flex direction="column" p={[1]}>
              <Box w={[1]}>
                <Field
                  name="msisdn"
                  component={TextField}
                  hintText="msisdn"
                  floatingLabelText="MSISDN"
                  validate={[required, valuemin]}
                />
              </Box>
              <Box w={[1]}>
                <Field
                  name="sim_card_number"
                  component={TextField}
                  hintText="Sim #"
                  floatingLabelText="Sim #"
                  validate={[required, valuemin]}
                />
              </Box>
              <Box w={[1]}>
                <Field
                  name="status"
                  component={SelectField}
                  floatingLabelText="Status"
                  validate={[required, valuemin]}
                >
                  <MenuItem value="new" primaryText="New" />
                  <MenuItem value="sold" primaryText="Sold" />
                  <MenuItem value="expired" primaryText="Expired" />
                </Field>
              </Box>
              <Flex w={[1]} justify={["flex-end"]} pt={[1]}>
                <FlatButton
                  label="Cancel"
                  primary={true}
                  onClick={this.handleClose.bind(this)}
                />
                <div style={{ width: 16 }} />
                <FlatButton
                  label="Save"
                  type="submit"
                  primary={true}
                  disabled={submitting}
                />
              </Flex>
            </Flex>
          </form>
        </Dialog>
      </div>
    );
  }
}
ModalEditDetail.propTypes = {
  open: PropTypes.bool,
  dataSelected: PropTypes.any,
  handleClose: PropTypes.func,
  handleSave: PropTypes.func
};
ModalEditDetail.defaultProps = {
  open: false,
  dataSelected: {}
};

//export default ModalEditDetail;

const formed = reduxForm({
  form: "edit-sim-form"
})(ModalEditDetail);

const mapStateToProps = (state, props) => {
  const initialValues = props.dataSelected;
  return {
    initialValues
  };
};

export default connect(mapStateToProps, {})(formed);



// WEBPACK FOOTER //
// ./src/sim/ModalEditDetail.js